import {
  FETCH_MASTER_MANIFEST_PENDING,
  FETCH_MASTER_MANIFEST_REJECTED,
  FETCH_MASTER_MANIFEST_FULFILLED,
} from "../../constants/masterManifest";

const initialState = {
  loading: false,
  error: false,
  success: false,
  data: null,
};

const masterManifest = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MASTER_MANIFEST_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: state.data ?? null,
      };
    case FETCH_MASTER_MANIFEST_REJECTED:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        data: null,
      };
    case FETCH_MASTER_MANIFEST_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action.payload.data,
      };
    default:
      return state;
  }
};

export default masterManifest;
